import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message, Tooltip } from '@/components';
import { Popover } from 'antd';
import { RootStore } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './apps.less';
import classNames from 'classnames';
import { elkLog } from '@/utils/elkReport';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'user' | 'meeting'>> {
  RTCInstance?: RootStore['rtc'];
  user?: RootStore['user'];
  meeting?: RootStore['meeting'];
  switchWhiteboard: () => void;
  switchCodeEditor: () => void;
}
const ApplicationsBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    meeting: store.meeting,
    user: store.user,
  };
})(
  observer((props) => {
    const { RTCInstance, user, meeting, switchWhiteboard, switchCodeEditor } = props;
    const [isApplicationPopoverVisible, setIsApplicationPopoverVisible] = React.useState(false);
    const { formatMessage } = useIntl();

    return (
      <Popover
        align={{ offset: [0, 12] }}
        overlayClassName="application-popover"
        placement="top"
        visible={isApplicationPopoverVisible && !RTCInstance?.breakLineReconnecting}
        content={
          <div className={styles['application-menu']}>
            <div className={styles['menu-item']} onMouseDown={switchWhiteboard}>
              <Icon className={styles.icon} name="icon-whiteboard1" />
              <span className={styles.text}>{formatMessage({ id: 'WHITEBOARD' })}</span>
            </div>
            {meeting?.codeEditorShouldBeOpen && (
              <div className={styles['menu-item']} onMouseDown={switchCodeEditor}>
                <Icon className={styles.icon} name="icon-code" />
                <span className={styles.text}>{formatMessage({ id: 'EDITOR' })}</span>
              </div>
            )}
          </div>
        }
      >
        <ActionBtn
          tooltip={meeting?.whiteboardUid ? formatMessage({ id: 'WHITEBOARD' }) : ''}
          title={formatMessage({ id: 'APPLICATION' })}
          className={classNames(styles.appsBtn, {
            [styles.disabled]: meeting?.screenUid || RTCInstance?.breakLineReconnecting,
          })}
          onClick={() => {
            if (RTCInstance?.breakLineReconnecting) {
              return;
            }
            if (meeting?.screenUid) {
              if (meeting?.screenUid === user?.mid) {
                message.info({
                  content: formatMessage({ id: 'SCREEN_SHARED' }),
                  noIcon: true,
                });
              } else {
                message.info({
                  content: formatMessage({ id: 'OTHER_SHAREDING_SCREEN' }),
                  noIcon: true,
                });
              }
            } else {
              elkLog('打开应用按钮');
              setIsApplicationPopoverVisible(!isApplicationPopoverVisible);
            }
          }}
          tabIndex={0}
          onBlur={() => setIsApplicationPopoverVisible(false)}
        >
          <Icon className={styles.icon} name="icon-application1" size={24} mode="symbol" />
        </ActionBtn>
      </Popover>
    );
  })
);

export default ApplicationsBtn;
